import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=d3360f72&scoped=true&"
import script from "./Staff.vue?vue&type=script&lang=js&"
export * from "./Staff.vue?vue&type=script&lang=js&"
import style0 from "./Staff.vue?vue&type=style&index=0&id=d3360f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3360f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3360f72')) {
      api.createRecord('d3360f72', component.options)
    } else {
      api.reload('d3360f72', component.options)
    }
    module.hot.accept("./Staff.vue?vue&type=template&id=d3360f72&scoped=true&", function () {
      api.rerender('d3360f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Staff.vue"
export default component.exports